import axios from 'axios';

import ICvViewSearch from '../types/ICvViewSearch';
import IJobBoardSearchLogFilterDTO from '../types/IJobBoardSearchLogFilterDTO';

const url = 'wsreporting/api/cv-views/';
const cvViewUrl = 'wsreporting/api/cv-view/';

export const getCvViewsByJobBoards = (searchFilter: IJobBoardSearchLogFilterDTO) =>
  axios.post(`${url}get-views-by-job-boards`, searchFilter);

export const getAggregateCvViewsByJobBoards = (searchFilter: IJobBoardSearchLogFilterDTO) =>
  axios.post(`${url}get-agg-views-by-job-boards`, searchFilter);

export const getCvCViewsByUsersAndJobBoards = (searchFilter: IJobBoardSearchLogFilterDTO) =>
  axios.post(`${url}get-views-by-users-and-job-boards`, searchFilter);

export const getCvViewsDailyTrend = (searchFilter: IJobBoardSearchLogFilterDTO) =>
  axios.post(`${url}get-daily-trend`, searchFilter);

export const getCvViewsBySource = (searchFilter: IJobBoardSearchLogFilterDTO) =>
  axios.post(`${url}get-views-by-source`, searchFilter);

export const getCvViewsWebAndExtension = (searchFilter: IJobBoardSearchLogFilterDTO) =>
  axios.post(`${url}get-views-by-web-extension`, searchFilter);

export const getCvViewsWebAndExtensionUsers = (searchFilter: IJobBoardSearchLogFilterDTO) =>
  axios.post(`${url}get-views-by-web-extension-users`, searchFilter);

export const getCvViewByKeysAndUserEmail = (cvViewSearch: ICvViewSearch) =>
  axios.post(`${cvViewUrl}get-views-by-keys`, cvViewSearch);
